define(["exports", "../Typography", "styled-components"], function (_exports, _Typography, _styledComponents) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _styledComponents = _interopRequireDefault(_styledComponents);
  var TextWithIcon = (0, _styledComponents.default)(_Typography.P).withConfig({
    displayName: "TextWithIcon",
    componentId: "sc-5w4asf-0"
  })(["display:", ";font-size:1.4em;line-height:1.7;margin:", ";padding-left:24px;position:relative;+ p{padding-top:4px;}"], function (_ref) {
    var inline = _ref.inline;
    return inline ? 'inline-block' : 'block';
  }, function (_ref2) {
    var inline = _ref2.inline;
    return inline ? '0 4px 0 0' : '0';
  });
  var _default = TextWithIcon;
  _exports.default = _default;
});